import { render, staticRenderFns } from "./PayRollPage.vue?vue&type=template&id=e8c97d06&scoped=true&"
import script from "./PayRollPage.vue?vue&type=script&lang=js&"
export * from "./PayRollPage.vue?vue&type=script&lang=js&"
import style0 from "./PayRollPage.vue?vue&type=style&index=0&id=e8c97d06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c97d06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8c97d06')) {
      api.createRecord('e8c97d06', component.options)
    } else {
      api.reload('e8c97d06', component.options)
    }
    module.hot.accept("./PayRollPage.vue?vue&type=template&id=e8c97d06&scoped=true&", function () {
      api.rerender('e8c97d06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/responsible/payroll/PayRollPage.vue"
export default component.exports